<!-- Выбирает автопарк для машины или фильтра списка транспорта -->
<template>
  <BaseSelect
    v-bind="$attrs"
    :options="fleetParkStore.fleetParkSelectOptions"
    :model-value="modelValue"
    :placeholder="placeholder"
    :clearable="clearable"
    :searchable="true"
    :with-button="withButton"
    button-label="Добавить автопарк"
    no-results-text="Автопарк не найден"
    @update:model-value="$emit('update:modelValue', $event)"
    @change="$emit('change', $event ? $event.value : null)"
    @button-click="showCreateModal = true"
  />

  <FleetParkModal
    v-if="showCreateModal"
    :visible="true"
    @close="showCreateModal = false"
    @created="handleCreated"
  />
</template>

<script>
import { useFleetParkStore } from "@/stores/fleetParkStore";
import FleetParkModal from "@/components/Fleet/Park/Modal.vue";

export default {
  name: "VehicleFleetParkSelect",

  inheritAttrs: false,

  components: {
    FleetParkModal,
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: null,
    },
    placeholder: {
      type: String,
      default: "Не входит в автопарк",
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    withButton: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["update:modelValue", "change"],
  data() {
    return {
      showCreateModal: false,
    };
  },
  computed: {
    fleetParkStore() {
      return useFleetParkStore();
    },
  },
  methods: {
    handleCreated(fleetPark) {
      this.$emit("update:modelValue", fleetPark.id);
      this.$emit("change", fleetPark.id);
    },
  },
  async mounted() {
    await this.fleetParkStore.fetchFleetParks();
  },
};
</script>
